import filtype from './filtype'

const stedsforholdrapporter = {
    tunnelulykker: {
        aktivertITrine: false,
        tekniskNavn: 'tunnelulykker',
        visningsnavn: 'Tunnelulykker',
        filtyper: [filtype.pdf]
    },
    ulykker_pa_bru: {
        aktivertITrine: false,
        tekniskNavn: 'ulykker_pa_bru',
        visningsnavn: 'Ulykker på bru',
        filtyper: [filtype.pdf]
    },
    ulykker_pa_motorveg: {
        aktivertITrine: false,
        tekniskNavn: 'ulykker_pa_motorveg',
        visningsnavn: 'Ulykker på motorveg',
        filtyper: [filtype.pdf]
    },
    ulykker_pa_tent_t_vegnettet: {
        aktivertITrine: false,
        tekniskNavn: 'ulykker_pa_tent_t_vegnettet',
        visningsnavn: 'Ulykker på TENT-T vegnettet',
        filtyper: [filtype.pdf]
    },
    ulykker_og_transportkorridorene: {
        aktivertITrine: false,
        tekniskNavn: 'ulykker_og_transportkorridorene',
        visningsnavn: 'Ulykker og transportkorridorene',
        filtyper: [filtype.pdf]
    }
}

export default stedsforholdrapporter
